import { render, staticRenderFns } from "./PagePlaceCategory.vue?vue&type=template&id=5cf18978&"
import script from "./PagePlaceCategory.vue?vue&type=script&lang=js&"
export * from "./PagePlaceCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cf18978')) {
      api.createRecord('5cf18978', component.options)
    } else {
      api.reload('5cf18978', component.options)
    }
    module.hot.accept("./PagePlaceCategory.vue?vue&type=template&id=5cf18978&", function () {
      api.rerender('5cf18978', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/placeCategory/PagePlaceCategory.vue"
export default component.exports